import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-clear-filters',
  templateUrl: './clear-filters.component.html',
  styleUrls: ['./clear-filters.component.scss']
})
export class ClearFiltersComponent {
  @Input() filters: { [key: string]: any } = {};
  @Input() enabled: boolean = false; // new input
  @Output() cleared = new EventEmitter<void>();

  get hasActiveFilters(): boolean {
    return Object.values(this.filters).some(value =>
      value !== null && value !== '' && value !== false
    );
  }

  get isButtonEnabled(): boolean {
    return this.enabled && this.hasActiveFilters;
  }

  clearFilters() {
    for (const key in this.filters) {
      if (this.filters.hasOwnProperty(key)) {
        this.filters[key] = '';
      }
    }

    this.cleared.emit(); // Notify parent
  }
}

